"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessOwnershipRejectionReason = exports.BusinessOwnershipVerificationStateKind = exports.BUSINESS_OWNERSHIP_ACCEPTED_DOCUMENT_TYPES = exports.BUSINESS_OWNERSHIP_DOCUMENT_REQUIREMENTS_BY_BUNDLE_TYPE = exports.BusinessOwnershipDocumentRole = exports.BusinessOwnershipDocumentBundleType = exports.BusinessOwnershipVerificationFlow = exports.ATTESTED_INCOME_BUSINESS_ENTITY_TYPES = exports.IncomeBusinessEntityType = exports.BusinessEntityType = exports.BusinessOwnershipVerificationStatus = void 0;
const documentUpload_1 = require("./documentUpload");
/** @TranslateToPython */
var BusinessOwnershipVerificationStatus;
(function (BusinessOwnershipVerificationStatus) {
    BusinessOwnershipVerificationStatus["notApplicable"] = "notApplicable";
    BusinessOwnershipVerificationStatus["waitingDocuments"] = "waitingDocuments";
    BusinessOwnershipVerificationStatus["documentPendingReview"] = "documentPendingReview";
    BusinessOwnershipVerificationStatus["documentReviewSuccess"] = "documentReviewSuccess";
    BusinessOwnershipVerificationStatus["reviewFailWaitingDocumentResubmission"] = "reviewFailWaitingDocumentResubmission";
})(BusinessOwnershipVerificationStatus || (exports.BusinessOwnershipVerificationStatus = BusinessOwnershipVerificationStatus = {}));
/** @TranslateToPython */
var BusinessEntityType;
(function (BusinessEntityType) {
    BusinessEntityType["llc"] = "llc";
    BusinessEntityType["sCorp"] = "sCorp";
    BusinessEntityType["bCorp"] = "bCorp";
    BusinessEntityType["other"] = "other";
})(BusinessEntityType || (exports.BusinessEntityType = BusinessEntityType = {}));
/**
 * What ops read off a self-employed borrower's tax return. Wider than BusinessEntityType because the income flow
 * verifies businesses of any structure, not just the LLCs that can hold title, and a Schedule C often doesn't
 * state one at all -- hence `unclear`, so ops records what the document shows instead of guessing.
 * @TranslateToPython
 */
var IncomeBusinessEntityType;
(function (IncomeBusinessEntityType) {
    IncomeBusinessEntityType["llc"] = "llc";
    IncomeBusinessEntityType["sCorp"] = "sCorp";
    IncomeBusinessEntityType["cCorp"] = "cCorp";
    IncomeBusinessEntityType["partnership"] = "partnership";
    IncomeBusinessEntityType["soleProprietorship"] = "soleProprietorship";
    IncomeBusinessEntityType["other"] = "other";
    IncomeBusinessEntityType["unclear"] = "unclear";
})(IncomeBusinessEntityType || (exports.IncomeBusinessEntityType = IncomeBusinessEntityType = {}));
exports.ATTESTED_INCOME_BUSINESS_ENTITY_TYPES = [
    IncomeBusinessEntityType.llc,
    IncomeBusinessEntityType.sCorp,
    IncomeBusinessEntityType.cCorp,
    IncomeBusinessEntityType.partnership,
    IncomeBusinessEntityType.soleProprietorship,
    IncomeBusinessEntityType.other,
];
/**
 * Which product journey owns a business_ownership_verification row.
 * llcTitle: the property is titled to an LLC and the borrower uploads the three LLC documents.
 * incomeBusinessOwnership: a self-employed borrower's business accounts, verified automatically via
 * Middesk and, when that fails, by a tax return the borrower uploads.
 * employmentVerificationSosStanding: a self-employed borrower's business, verified via Middesk for SOS
 * standing and applicant association.
 */
/** @TranslateToPython */
var BusinessOwnershipVerificationFlow;
(function (BusinessOwnershipVerificationFlow) {
    BusinessOwnershipVerificationFlow["llcTitle"] = "llcTitle";
    BusinessOwnershipVerificationFlow["incomeBusinessOwnership"] = "incomeBusinessOwnership";
    BusinessOwnershipVerificationFlow["employmentVerificationSosStanding"] = "employmentVerificationSosStanding";
})(BusinessOwnershipVerificationFlow || (exports.BusinessOwnershipVerificationFlow = BusinessOwnershipVerificationFlow = {}));
/** @TranslateToPython */
var BusinessOwnershipDocumentBundleType;
(function (BusinessOwnershipDocumentBundleType) {
    BusinessOwnershipDocumentBundleType["form1040ScheduleC"] = "form1040ScheduleC";
    BusinessOwnershipDocumentBundleType["form1120sScheduleK1"] = "form1120sScheduleK1";
    BusinessOwnershipDocumentBundleType["articlesOfIncorporationAndOperatingAgreement"] = "articlesOfIncorporationAndOperatingAgreement";
    BusinessOwnershipDocumentBundleType["other"] = "other";
})(BusinessOwnershipDocumentBundleType || (exports.BusinessOwnershipDocumentBundleType = BusinessOwnershipDocumentBundleType = {}));
var BusinessOwnershipDocumentRole;
(function (BusinessOwnershipDocumentRole) {
    BusinessOwnershipDocumentRole["taxReturn"] = "taxReturn";
    BusinessOwnershipDocumentRole["articlesOfIncorporation"] = "articlesOfIncorporation";
    BusinessOwnershipDocumentRole["operatingAgreement"] = "operatingAgreement";
})(BusinessOwnershipDocumentRole || (exports.BusinessOwnershipDocumentRole = BusinessOwnershipDocumentRole = {}));
exports.BUSINESS_OWNERSHIP_DOCUMENT_REQUIREMENTS_BY_BUNDLE_TYPE = {
    [BusinessOwnershipDocumentBundleType.form1040ScheduleC]: [{ role: BusinessOwnershipDocumentRole.taxReturn, documentType: documentUpload_1.DocumentUploadType.BUSINESS_OWNERSHIP_TAX_RETURN }],
    [BusinessOwnershipDocumentBundleType.form1120sScheduleK1]: [{ role: BusinessOwnershipDocumentRole.taxReturn, documentType: documentUpload_1.DocumentUploadType.BUSINESS_OWNERSHIP_TAX_RETURN }],
    [BusinessOwnershipDocumentBundleType.articlesOfIncorporationAndOperatingAgreement]: [
        { role: BusinessOwnershipDocumentRole.operatingAgreement, documentType: documentUpload_1.DocumentUploadType.BUSINESS_OWNERSHIP_INCOME_DOC },
    ],
    [BusinessOwnershipDocumentBundleType.other]: [{ role: BusinessOwnershipDocumentRole.taxReturn, documentType: documentUpload_1.DocumentUploadType.BUSINESS_OWNERSHIP_TAX_RETURN }],
};
exports.BUSINESS_OWNERSHIP_ACCEPTED_DOCUMENT_TYPES = [documentUpload_1.DocumentUploadType.BUSINESS_OWNERSHIP_INCOME_DOC, documentUpload_1.DocumentUploadType.BUSINESS_OWNERSHIP_TAX_RETURN];
/**
 * Terminal and in-progress states of a business-ownership verification job.
 * Shared across the backend manager, the frontend polling page, and e2e tests
 * so the three don't drift out of sync.
 */
var BusinessOwnershipVerificationStateKind;
(function (BusinessOwnershipVerificationStateKind) {
    BusinessOwnershipVerificationStateKind["pendingUserAction"] = "pendingUserAction";
    BusinessOwnershipVerificationStateKind["pendingAvenAction"] = "pendingAvenAction";
    BusinessOwnershipVerificationStateKind["verified"] = "verified";
    BusinessOwnershipVerificationStateKind["rejected"] = "rejected";
    BusinessOwnershipVerificationStateKind["inconclusive"] = "inconclusive";
    BusinessOwnershipVerificationStateKind["notApplicable"] = "notApplicable";
})(BusinessOwnershipVerificationStateKind || (exports.BusinessOwnershipVerificationStateKind = BusinessOwnershipVerificationStateKind = {}));
/**
 * Why a business-ownership verification was rejected. The frontend reads the automatic (Middesk) members to
 * decide whether a rejected borrower is worth offering the tax return path.
 * @TranslateToPython
 */
var BusinessOwnershipRejectionReason;
(function (BusinessOwnershipRejectionReason) {
    // Document review reasons (manual/docs path)
    BusinessOwnershipRejectionReason["wrongDocument"] = "wrongDocument";
    BusinessOwnershipRejectionReason["documentExpired"] = "documentExpired";
    BusinessOwnershipRejectionReason["documentIllegible"] = "documentIllegible";
    BusinessOwnershipRejectionReason["borrowerNotListedAsMember"] = "borrowerNotListedAsMember";
    BusinessOwnershipRejectionReason["businessNotInGoodStanding"] = "businessNotInGoodStanding";
    BusinessOwnershipRejectionReason["incorrectBusinessName"] = "incorrectBusinessName";
    BusinessOwnershipRejectionReason["incorrectPropertyAddress"] = "incorrectPropertyAddress";
    BusinessOwnershipRejectionReason["missingRequiredSignatures"] = "missingRequiredSignatures";
    BusinessOwnershipRejectionReason["cCorp"] = "cCorp";
    // Automatic verification reasons (Middesk path)
    BusinessOwnershipRejectionReason["businessNotFound"] = "businessNotFound";
    BusinessOwnershipRejectionReason["businessRejected"] = "businessRejected";
    BusinessOwnershipRejectionReason["noPeopleFound"] = "noPeopleFound";
    BusinessOwnershipRejectionReason["ownerMismatch"] = "ownerMismatch";
    BusinessOwnershipRejectionReason["ineligibleEntityType"] = "ineligibleEntityType";
    BusinessOwnershipRejectionReason["insufficientOwnership"] = "insufficientOwnership";
    BusinessOwnershipRejectionReason["ownershipPercentageMismatch"] = "ownershipPercentageMismatch";
})(BusinessOwnershipRejectionReason || (exports.BusinessOwnershipRejectionReason = BusinessOwnershipRejectionReason = {}));
